import { CatalogPreview, SearchQuery } from 'modules/domains';
import * as t from './actionTypes';
import {
  CatalogPreviewErrorAction,
  CatalogPreviewRequestAction,
  CatalogPreviewResponseAction,
} from './types';

/*------------------------------------------------------------------------------------------------*/
/* Preview Catalog Query Actions                                                             */
/*------------------------------------------------------------------------------------------------*/
export const catalogPreviewQueryRequest = (
  catalogName?: string,
  searchQuery?: SearchQuery,
): CatalogPreviewRequestAction => ({
  type: t.CATALOG_PREVIEW_REQUEST,
  isLoading: true,
  catalogName,
  searchQuery,
});

export const catalogPreviewQueryResponse = (
  catalogPreviews: CatalogPreview[],
): CatalogPreviewResponseAction => ({
  type: t.CATALOG_PREVIEW_RESPONSE,
  isLoading: false,
  catalogPreviews,
});

export const catalogPreviewQueryError = (error: string): CatalogPreviewErrorAction => ({
  type: t.CATALOG_PREVIEW_ERROR,
  isLoading: false,
  error,
});
